/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InventoryRecordItemDto } from './InventoryRecordItemDto';
export type CreateInventoryRecordWithItemsDto = {
  /**
   * Destination location ID
   */
  destinationLocationId: number;
  /**
   * Supplier for the whole record (step 1). If omitted, inferred from items.individualUnits[].supplierId when present.
   */
  supplierId?: number;
  /**
   * Record status
   */
  status: CreateInventoryRecordWithItemsDto.status;
  /**
   * Items in the inventory record
   */
  items: Array<InventoryRecordItemDto>;
  /**
   * User ID who registered the record (optional, will be ignored and replaced with authenticated user ID)
   */
  registeredById?: string;
};
export namespace CreateInventoryRecordWithItemsDto {
  /**
   * Record status
   */
  export enum status {
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
  }
}
